var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgLogoLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.983 17.1968C16.1914 17.1968 17.171 16.2172 17.171 15.0088C17.171 13.8004 16.1914 12.8208 14.983 12.8208C13.7746 12.8208 12.795 13.8004 12.795 15.0088C12.795 16.2172 13.7746 17.1968 14.983 17.1968Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.237 18.8552V30.9942H23.006V24.9912C23.006 23.4072 23.304 21.8732 25.268 21.8732C27.205 21.8732 27.229 23.6842 27.229 25.0912V30.9952H31V24.3382C31 21.0682 30.296 18.5552 26.474 18.5552C24.639 18.5552 23.409 19.5622 22.906 20.5152H22.855V18.8552H19.237ZM13.095 18.8552H16.87V30.9942H13.095V18.8552Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLogoLinkedin);
export default __webpack_public_path__ + "static/media/imgLogoLinkedin.afbf96ccc8d1e98d9c23d4ad17df253c.svg";
export { ForwardRef as ReactComponent };